// Not sure this config is useful since it was working while missing some ns
export const namespaces = ['core', 'betting', 'gaming', 'user', 'loyalty'];
export const defaultNamespace = 'core';
